import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const NoLinkGlyph = /*#__PURE__*/createElement("g", {
  id: "no_link"
}, /*#__PURE__*/createElement("path", {
  d: "M23.3,62.9c-2.6,0-5.1-1-7.1-2.9c-3.9-3.9-3.9-10.3,0-14.2l12.3-12.3c3.9-3.9,10.3-3.9,14.2,0c3.9,3.9,3.9,10.3,0,14.2l0,0 L30.4,60C28.4,61.9,25.9,62.9,23.3,62.9z M35.6,33.6c-1.9,0-3.6,0.7-5,2L18.3,47.9c-2.7,2.7-2.7,7.2,0,9.9s7.2,2.7,9.9,0l12.3-12.3 c2.7-2.7,2.7-7.2,0-9.9C39.2,34.3,37.4,33.6,35.6,33.6z"
}), /*#__PURE__*/createElement("path", {
  d: "M58.6,21.6c-5.5,0-10,4.5-10,10l0,0l3,3v-3c0-3.9,3.2-7,7-7s7,3.2,7,7V49c0,3.9-3.2,7-7,7s-7-3.2-7-7v-3.7l-3,3V49 c0,5.5,4.5,10,10,10s10-4.5,10-10V31.6C68.7,26.1,64.2,21.6,58.6,21.6z"
}));
const NoLink = createSvg({
  name: 'no_link',
  path: NoLinkGlyph
});

export default NoLink;
export { NoLinkGlyph };
